var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c(
        "div",
        [
          _c(
            "base-modal",
            {
              model: {
                value: _vm.isVisible,
                callback: function($$v) {
                  _vm.isVisible = $$v
                },
                expression: "isVisible"
              }
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "text-center px-2 my-2",
                      attrs: { sm: "12", md: "6" }
                    },
                    [
                      _c(
                        "base-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.showGrantAccess = true
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("clinic-history.grant-access")))]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "text-center px-2 my-2",
                      attrs: { sm: "12", md: "6" }
                    },
                    [
                      _c(
                        "base-button",
                        {
                          attrs: { white: "" },
                          on: {
                            click: function($event) {
                              _vm.showProfAndCenterAuthorizedModal = true
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("clinic-history.access-authorizated"))
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("history-prof-and-center-authorized", {
            model: {
              value: _vm.showProfAndCenterAuthorizedModal,
              callback: function($$v) {
                _vm.showProfAndCenterAuthorizedModal = $$v
              },
              expression: "showProfAndCenterAuthorizedModal"
            }
          }),
          _vm._v(" "),
          _c("history-grant-access", {
            model: {
              value: _vm.showGrantAccess,
              callback: function($$v) {
                _vm.showGrantAccess = $$v
              },
              expression: "showGrantAccess"
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b0fa295", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b0fa295","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/HistoryGrantAccessMenu.vue
// module id = 2094
// module chunks = 116